import { IApiResponse } from './shared/common';

export type IOutletDetailResponse = IApiResponse<OutletDetail>;

export enum DayWeekEnum {
  SENIN = '1',
  SELASA = '2',
  RABU = '3',
  KAMIS = '4',
  JUMAT = '5',
  SABTU = '6',
  MINGGU = '7',
}

export const DayWeekLabel: Record<DayWeekEnum, string> = {
  [DayWeekEnum.SENIN]: 'Senin',
  [DayWeekEnum.SELASA]: 'Selasa',
  [DayWeekEnum.RABU]: 'Rabu',
  [DayWeekEnum.KAMIS]: 'Kamis',
  [DayWeekEnum.JUMAT]: 'Jumat',
  [DayWeekEnum.SABTU]: 'Sabtu',
  [DayWeekEnum.MINGGU]: 'Minggu',
};

export interface OutletDetail {
  branch_id: number;
  branch_user_id: number;
  branch_name: string;
  phone_number: string;
  branch_email: string;
  branch_logo: string;
  branch_comco_code: string;
  branch_point_id: number;
  branch_point_name: string;
  address: string;
  pharmacist: string;
  sia: string;
  sipa: string;
  longitude: number;
  latitude: number;
  operational_schedule: OperationalSchedule[];
}

export interface OperationalSchedule {
  OutletID: string;
  DayWeek: DayWeekEnum;
  OpenTime: string;
  CloseTime: string;
  OutletHolidayYN: string;
  ActiveYN: string;
  LastUpdate: string;
  UpdatedBy: string;
}

export type IOutletDetailProduct = IApiResponse<OutletProduct[]>;

export interface OutletProduct {
  id: number;
  product_name: string;
  min_price: string;
  max_price: string;
  branch_name: string;
  branch_logo: string;
  branch_city: string;
  price_range: string;
  final_price_range: string;
  ppn: string;
  image: string;
}

export type IOutletDetailService = IApiResponse<OutletService[]>;

export interface OutletService {
  bpis_id: number;
  individual_id: number;
  doctor_image: string;
  service_name: string;
  doctor_name: string;
  min_price: string;
  max_price: string;
  price: string;
  is_event: boolean;
  payment_method: string[];
  service_method: string[];
}
